import React from 'react';
import { Card, CardContent } from '../../components/ui/card';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-cream" data-testid="privacy-policy-page">
      <section className="bg-terracotta py-16">
        <div className="max-w-4xl mx-auto px-4">
          <h1 className="font-heading text-4xl text-white">Privacy Policy</h1>
          <p className="font-body text-white/80 mt-2">Last updated: January 2026</p>
        </div>
      </section>
      
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4">
          <Card className="bg-white rounded-2xl border-none shadow-sm">
            <CardContent className="p-8 md:p-12 space-y-8 font-body text-gray-700 leading-relaxed">
              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Introduction</h2>
                <p>Dharma Astra Association ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or make donations to our organization.</p>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Information We Collect</h2>
                <p className="mb-4">We may collect information about you in various ways:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Personal Data:</strong> Name, email address, phone number, postal address, PAN card number (for tax exemption), and payment information.</li>
                  <li><strong>Donation Information:</strong> Donation amount, frequency, and designated projects.</li>
                  <li><strong>Volunteer Information:</strong> Skills, availability, areas of interest, and identification documents.</li>
                  <li><strong>Usage Data:</strong> IP address, browser type, pages visited, and time spent on our website.</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">How We Use Your Information</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Process and manage donations</li>
                  <li>Issue tax exemption certificates (80G)</li>
                  <li>Communicate about our projects and activities</li>
                  <li>Coordinate volunteer activities</li>
                  <li>Improve our website and services</li>
                  <li>Comply with legal obligations</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Data Security</h2>
                <p>We implement appropriate technical and organizational security measures to protect your personal information. All payment transactions are processed through Razorpay's secure payment gateway, which is PCI-DSS compliant.</p>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Data Retention</h2>
                <p>We retain your personal information for as long as necessary to fulfill the purposes outlined in this policy, comply with legal obligations, resolve disputes, and enforce our agreements. Donation records are kept for a minimum of 8 years as required by Indian tax laws.</p>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Your Rights</h2>
                <p>You have the right to access, correct, or delete your personal information. To exercise these rights, please contact us at info@dharmastra.org.</p>
              </div>

              <div>
                <h2 className="font-heading text-2xl font-semibold text-gray-900 mb-4">Contact Us</h2>
                <p>If you have questions about this Privacy Policy, please contact us:</p>
                <p className="mt-2">Email: support@dharma-astra.org<br />Phone: +91 8977116677</p>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
